<template>
  <div class="el-material-selector">
    <el-dialog
      maxHeight="null"
      width="500px"
      :title="$t('page.productInfo.dialog.title')"
      @close="close"
      :visible.sync="dialogFormVisible1"
      custom-class="sorting-code-number"
    >
      <div class="el-dialog__body-bodys" v-if="dialogFormVisible1">
        <div class="treeBox">
          <el-tree
            :props="treeProps"
            :load="loadNode"
            ref="tree"
            node-key="id"
            :default-checked-keys="defaultData"
            :expand-on-click-node="false"
            :check-strictly="false"
            show-checkbox
            :draggable="false"
            lazy
            show-line
          >
          </el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="cancel"
          >{{$t('page.productInfo.btn.cancel') }}</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="handleTrue"
          >{{$t('page.productInfo.btn.confirm') }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
  import Cookies from 'js-cookie';
  import {qryMatcateryTreeList} from "@/api/supRegister";

  export default {
    name: 'chooseTree',
    watch: {
      dialogFormVisible(item) {
        this.dialogFormVisible1 = item;
        if (item) {
          this.tableData = [];
          this.materialsData = [];
          this.isTurnPage = false;
          this.formData = {
            // matName: '',
            // matNum: '',
            pageNo: 1,
            pageSize: 10,
            // catalogId: '',
            matcateryLevel: '',
            matcateryCode: '',
            matcateryAlias: '',
            matcodeName: '',
          };
        }
      },
    },
    props: {
      dialogFormVisible: {
        type: Boolean,
        default: false
      },
      headers: {
        type: Object,
        default: ()=>{
          return {
            APP_TOKEN: Cookies.get('appToken'),
            Authorization: Cookies.get('access_token')
          };
        }
      },
      defaultData: {
        type: Array,
        default: []
      }
    },
    created() {
    },
    data() {
      return {
        lineClampBody: true,
        loading: false,
        dialogFormVisible1: this.dialogFormVisible,
        conditionCheckbox: true,
        tableData: [],
        treeProps: {
          label: "name",
          children: "qryMatcateryTreeBOList",
          isLeaf: "leaf"
        },
        gridData: [],
        dialogTableVisibletextarea: false,
        formData: {
          pageNo: 1,
          pageSize: 10,
          matcateryLevel: '',
          matcateryCode: '',
          matcateryAlias: '',
          matcodeName: '',
        },
        textarea: '',
        formLabelWidth: '120px',
        present: '',
        total: 0,
        lastTime: {
          button: false
        },
        materialsData: [], // 物资选择数据
        isTurnPage: false, // 是否有翻页
        treeArray: []
      };
    },
    methods: {
      close() {
        this.$emit('update:dialogFormVisible', false);
      },
      cancel() {
        this.$emit('update:dialogFormVisible', false);
      },
      loadNode(node, resolve) {
        if (node.level === 0) {
          qryMatcateryTreeList({
            parentMatcateryCode: "00"
          }).then(res => {
            const nodes = res.data.data.map(item => ({
              id: item.matcateryCode,
              qryMatcateryTreeBOList: [],
              name: item.matcateryName,
              leaf: window.languagezh_cn?item.isOrder != 0:true,
              parentMatcateryCode: item.parentMatcateryCode,
              matcateryTreePath: item.matcateryTreePath,
              unitName:item.unitName,
              unitCode:item.unitCode,
              level: item.matcateryLevel
            }));
            resolve(nodes);
            // console.log(nodes, "打印服务数据");
          });
        } else {
          qryMatcateryTreeList({
            parentMatcateryCode: node.data.id
          }).then(res => {
            const nodes = res.data.data.map(item => ({
              id: item.matcateryCode,
              name: item.matcateryName,
              qryMatcateryTreeBOList: [],
              leaf: item.isOrder != 0,
              parentMatcateryCode: item.parentMatcateryCode,
              matcateryTreePath: item.matcateryTreePath,
              unitName:item.unitName,
              unitCode:item.unitCode,
              level: item.matcateryLevel
            }));
            resolve(nodes);
            // console.log(nodes, "打印服务数据++");
          });
        }
        if (node.level > 1) return resolve([]);
      },
      handleTrue() {
        let treeData = this.forData(this.$refs.tree.getCheckedNodes());
        this.$emit('handleTrue', treeData);
        this.$emit('update:dialogFormVisible', false);
      },
      forData(treeData) {
        let _this = this;
        let treeData1 = JSON.parse(JSON.stringify(treeData));
        treeData.map(item => {
          let id = item.id;
          for (let i = treeData1.length - 1; i >= 0; i-- ){
            if (treeData1[i].matcateryTreePath.indexOf("-" + id + "-") !== -1) {
              _this.$delete(treeData1,i);
            }
          }
        })
        return treeData1;
      },
    }
  };
</script>
<style scoped>
  .el-dialog__body-bodys {
    height: 100%;
    width: 460px;
    border: 1px solid #f2f2f2;
    overflow: auto;
    float: left;
  }
</style>
